export { default } from './PromotionalOverlay';
